import React, { createContext } from "react";

import useAuth from './hooks/useAuth';

const Context = createContext();

const AuthProvider = ({ children }) => {
    const {
        authenticated, user, loading, handleLogin, handleLogout
    } = useAuth;


    return(
        <Context.Provider value={{ authenticated, handleLogin, handleLogout, loading, user}}>
            {children} 
        </Context.Provider>
    );
}

export { Context, AuthProvider }; 